// extracted by mini-css-extract-plugin
export default {"zoomModal":"H4-z","image":"I4-z","button":"J4-z","isOverlayShown":"K4-z"};